import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FromSubcategoria = ({ fechaModal, subcategoria_id}) => {
  const inicialForm = {
    subcategoria_id : '',
    subcategoria    : '',
    desconto        : 0,
    categoriaSelect : '',
    categoria_id    : ''
  }

  const [form, onChange, setForm, onChangeSelect] = useForm(inicialForm)
  const [listaCategoria, setListaCategoria]       = useState([])
  const [loading, setLoading]                     = useState(true)

  const listaCategorias = () => {
    let lista = []
    const url = rotas.categoriaSelect
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          lista = []
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i] = {"id":ret.lista[i].categoria_id, "title":ret.lista[i].categoria}
          }
          setListaCategoria(lista)
        }
      })
      return (lista)
    }catch(err){
    }
  }

  const editSubcategoria = (subcategoria_id) => {
    const url = rotas.subcategoria+subcategoria_id
    const retorno = rest.get(url)
    retorno.then(ret => {
      if (ret.success && ret.success == 'S') {
        ret.lista[0].categoriaSelect = {"id":ret.lista[0].categoria_id, "title":ret.lista[0].categoria}
        setForm(ret.lista[0])
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    if (listaCategorias()) {
      if(subcategoria_id != ''){
        editSubcategoria(subcategoria_id)
      }else{
        setForm(inicialForm)
        setLoading(false)
      }
    }
  },[])

  const validate = () => {
    if (form.categoria_id == '0' || form.categoria_id == ''){
      return true
    }
    return false
  }

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()

    // return true
    // if (validate()) {
    //   alert('Preenche os campos obrigatórios')
    //   return true
    // }

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.subcategoria+'gravar.php'
        if(subcategoria_id !== ''){
          return rest.post(url, form)
          .then(ret => {
            editSubcategoria(subcategoria_id)
            if (ret.success == 'S') {
              formSwal.fire('Salvo!',
                            ret.msg,
                            'success')
            }else{
              formSwal.fire('Erro!',
                            ret.msg,
                            'error')
            }
          })
        }else{
          return rest.put(url, form)
          .then(ret => {
            if (ret.success == 'S') {
              editSubcategoria(ret.retorno.insert_id)
              formSwal.fire('Salvo!',
                            ret.msg,
                            'success')
            }else{
              formSwal.fire('Erro!',
                            ret.msg,
                            'error')
            }
          })
        }
      }
    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md='2'>
                <FormGroup>
                  <Label for="subcategoria_id">Código</Label>
                  <Input
                    disabled
                    style     =  {{background: '#F9F9F9'}}
                    name      = "subcategoria_id"
                    id        = "subcategoria_id"
                    value     = {form.subcategoria_id}
                    onChange  = {onChange('subcategoria')}
                  />
                </FormGroup>
              </Col>

              <Col md='10'>
                <FormGroup>
                  <Label for="subcategoria">Subcategoria</Label>
                  <Input
                    required
                    name      = "subcategoria"
                    id        = "subcategoria"
                    value     = {form.subcategoria}
                    onChange  = {onChange('subcategoria')}
                  />
                </FormGroup>
              </Col>
            </Row>
{/* 
            <Row>
              <Col md='2'>
                <FormGroup>
                  <Label for="desconto">Desconto</Label>
                  <Input
                    required
                    name      = "desconto"
                    id        = "desconto"
                    value     = {form.desconto}
                    onChange  = {onChange('desconto')}
                  />
                </FormGroup>
              </Col>

              <Col md='10'>
                <FormGroup>
                  <ReactSelect
                    required
                    name          = "categoria"
                    label         = "Categoria"
                    placeholder   = "Selecione"
                    options       = {listaCategoria}
                    defaultValue  = {form.categoriaSelect}
                    onChange      = {onChangeSelect('categoriaSelect')}
                    onClick       = {form.categoria_id = form.categoriaSelect.id}
                    >
                  </ReactSelect>
                </FormGroup>
              </Col>
            </Row> */}

            <Col className="text-center p-3">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
            </Col>
          </Form>
        </ModalBody>
      </FormGroup>
    )
  }

}

export default FromSubcategoria
